var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import cxs from 'cxs/component';
import Theme, { marks, strMark } from 'Theme';
import { t } from 'helpers/i18n';
import History from 'helpers/History';
import { sections } from 'scenes/Main';
import UserLogout from 'modules/Users/containers/UserLogout';
import { Button } from 'elements';
import QueryParams from './QueryParams';
var NavBarDesktop = /** @class */ (function (_super) {
    __extends(NavBarDesktop, _super);
    function NavBarDesktop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleLink = function (activePath) { return function () {
            // console.log('NavBarDesktop - handleLink', activePath)
            History.push(activePath);
        }; };
        _this.handleSimulator = function () {
            var url;
            if (process.env.REACT_APP_SERVER.includes('simulator')) {
                url = 'https://simulator.crea-ticket.com';
            }
            else {
                url = 'https://demo.crea-ticket.com';
            }
            window.open(url, '_blank');
        };
        return _this;
    }
    NavBarDesktop.prototype.render = function () {
        var _this = this;
        var _a;
        var isCivitrip = ((_a = this.props.queryParams) === null || _a === void 0 ? void 0 : _a[strMark]) === marks.civitrip;
        return (React.createElement(Wrapper, null,
            sections(this.props.store.users.user, isCivitrip).map(function (section) { return (React.createElement(DropDown, { key: section.name },
                React.createElement(StyledButton, { onClick: function () { } }, t(section.name)),
                React.createElement(DropDownContent, null, section.links.map(function (link) { return (React.createElement(DropDownLink, { onClick: _this.handleLink(link.path), key: link.name }, t(link.name))); })))); }),
            React.createElement(UserLogout, null)));
    };
    NavBarDesktop = __decorate([
        inject('store')
    ], NavBarDesktop);
    return NavBarDesktop;
}(Component));
export default QueryParams(NavBarDesktop);
var Wrapper = cxs('div')({
    /*float: 'right',
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',*/
    zIndex: 2,
    /*background: 'yellow',*/
});
var DropDown = cxs('div')({
    float: 'left',
    overflow: 'hidden',
    ':hover div': {
        display: 'block'
    },
    ':hover > button': {
        color: Theme.color.primary
    }
});
var StyledButton = cxs(Button)({});
var DropDownContent = cxs('div')({
    display: 'none',
    position: 'absolute',
    backgroundColor: Theme.color.background,
    border: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    // borderTopWidth: 0,
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2)',
});
var DropDownLink = cxs(Button)({
    display: 'block',
    width: '100%',
    float: 'none',
    borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    ':last-child': {
        borderWidth: 0
    },
    ':hover': {
        color: Theme.color.primary
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/NavBarDesktop.tsx
// module id = 1053
// module chunks = 0